<template>
  <base-card class="links-and-devices">
    <div class="row d-flex">
      <div class="col-8 py-2">
        <top-links-clicked
          :entries="linksClicked"
          :loading="linksClickedLoading"
        />
      </div>
      <div class="col-4">
        <doughnut-chart
          :entries="deviceOpens"
          :has-background="false"
          :base-heading="true"
          :cut-out-percentage="60"
          :loading="deviceOpensLoading"
        />
      </div>
    </div>
  </base-card>
</template>
<script>
export default {

  name: 'AdminChart',
  props: {
    linksClicked: {
      type: Array,
      default: () => [],
    },
    linksClickedLoading: {
      type: Boolean,
      default: false,
    },
    deviceOpens: {
      type: Array,
      default: () => [],
    },
    deviceOpensLoading: {
      type: Boolean,
      default: false,
    },
    dataRange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pageSize: 10,
      fakeloading: false,
    };
  },
};
</script>
<style lang="css"
  scoped>
.links-and-devices {
  background-color: rgba(233, 173, 125, 0.3);
  ;
}
</style>
